export default __webpack_public_path__ + "static/media/Archdeacon's Helm of the Hallow Worlds.37102e5f.jpg";